export interface ComicApp {
  id: string;
  name: string;
  tagline: string;
  category: string;
  rating: number;
  score: number;
  platforms: string[];
  price: string;
  tags: string[];
  cover: string;
  summary: string;
  pros: string[];
  cons: string[];
  bestFor: string;
}

export const appCategories = [
  "全部",
  "免费追更",
  "正版日漫",
  "国漫原创",
  "韩漫专区",
  "追更管理",
] as const;

export const comicApps: ComicApp[] = [
  {
    id: "kuaikan",
    name: "快看漫画",
    tagline: "国漫原创内容社区",
    category: "国漫原创",
    rating: 4.8,
    score: 92,
    platforms: ["iOS", "Android", "Web"],
    price: "免费+会员",
    tags: ["原创国漫", "社区互动", "签到福利"],
    cover: "https://readdy.ai/api/search-image?query=A%20dynamic%20chinese%20manhua%20cover%20illustration%20of%20a%20confident%20young%20hero%20in%20action%20pose%20with%20vibrant%20coral%20orange%20and%20red%20color%20palette%2C%20comic%20book%20cover%20style%2C%20bold%20linework%2C%20dramatic%20lighting%2C%20energetic%20graphic%20novel%20aesthetic%2C%20high%20detail%20character%20art&width=600&height=800&seq=app-kuaikan&orientation=portrait",
    summary:
      "国内原创国漫的代表性平台，拥有大量独家连载与丰富的创作者社区。追更提醒、章节评论区氛围活跃，签到和看广告可免费获取阅读券，适合喜欢追国漫原创作品和参与互动讨论的读者。",
    pros: ["独家国漫多", "社区氛围活跃", "签到免费看"],
    cons: ["部分作品需会员", "广告较多"],
    bestFor: "喜欢国产原创漫画与社区互动的读者",
  },
  {
    id: "bilibili",
    name: "哔哩哔哩漫画",
    tagline: "正版日漫与精品国漫",
    category: "正版日漫",
    rating: 4.7,
    score: 89,
    platforms: ["iOS", "Android", "Web"],
    price: "免费+会员",
    tags: ["正版授权", "日漫海量", "同步更新"],
    cover: "https://readdy.ai/api/search-image?query=A%20cute%20pastel%20anime%20girl%20character%20on%20a%20soft%20pink%20and%20cream%20background%20holding%20a%20comic%20book%2C%20anime%20manga%20cover%20style%2C%20gentle%20clean%20lineart%2C%20soft%20shading%2C%20youthful%20and%20friendly%20mood%2C%20high%20quality%20illustration&width=600&height=800&seq=app-bilibili&orientation=portrait",
    summary:
      "依托哔哩哔哩生态的正版漫画应用，收录大量官方授权的日漫与精品国漫，和动漫作品联动紧密。支持离线缓存与跨端同步，弹幕式的章节评论区让看漫更有参与感，追更提醒稳定可靠。",
    pros: ["正版资源丰富", "与B站联动", "离线缓存"],
    cons: ["热门作品付费较多"],
    bestFor: "喜欢正版日漫与B站联动体验的用户",
  },
  {
    id: "tencent",
    name: "腾讯动漫",
    tagline: "大厂正版动漫平台",
    category: "国漫原创",
    rating: 4.6,
    score: 87,
    platforms: ["iOS", "Android", "Web"],
    price: "免费+会员",
    tags: ["大厂正版", "IP改编", "独家连载"],
    cover: "https://readdy.ai/api/search-image?query=A%20warm%20sunset%20anime%20landscape%20with%20a%20silhouetted%20hero%20overlooking%20a%20fantasy%20city%2C%20orange%20and%20amber%20toned%20manga%20cover%20art%2C%20cinematic%20composition%2C%20rich%20warm%20gradient%20sky%2C%20detailed%20illustration%20with%20storybook%20feel&width=600&height=800&seq=app-tencent&orientation=portrait",
    summary:
      "腾讯旗下正版动漫平台，坐拥大量热门IP改编作品与独家连载。阅读体验流畅，会员体系完整，配合腾讯系账号体系跨端无缝衔接。榜单与推荐算法成熟，能较快发现符合口味的新作品。",
    pros: ["IP资源雄厚", "阅读流畅", "算法推荐准"],
    cons: ["会员价格偏高"],
    bestFor: "追求大厂正版与稳定体验的用户",
  },
  {
    id: "dongman",
    name: "咚漫",
    tagline: "潮流韩漫精选",
    category: "韩漫专区",
    rating: 4.7,
    score: 90,
    platforms: ["iOS", "Android", "Web"],
    price: "免费+内购",
    tags: ["韩漫精选", "条漫阅读", "日更不断"],
    cover: "https://readdy.ai/api/search-image?query=A%20trendy%20korean%20webtoon%20cover%20illustration%20with%20stylish%20fashionable%20characters%20in%20modern%20urban%20setting%2C%20vibrant%20teal%20and%20coral%20color%20palette%2C%20clean%20webtoon%20lineart%2C%20fashion%20magazine%20energy%2C%20detailed%20character%20fashion%20and%20expressions&width=600&height=800&seq=app-dongman&orientation=portrait",
    summary:
      "专注韩漫精选的正版平台，条漫式阅读体验极佳，漫画更新节奏快、日更不断。题材覆盖恋爱、悬疑、奇幻与都市，画风精致时尚。每日签到与限时活动较多，适合喜欢韩漫潮流风格的读者。",
    pros: ["韩漫资源多", "更新节奏快", "画风精致"],
    cons: ["部分题材需内购"],
    bestFor: "钟爱韩漫与条漫阅读体验的用户",
  },
  {
    id: "fanqie",
    name: "番茄漫画",
    tagline: "海量免费漫画阅读",
    category: "免费追更",
    rating: 4.6,
    score: 86,
    platforms: ["iOS", "Android"],
    price: "免费",
    tags: ["全免费", "海量书库", "广告解锁"],
    cover: "https://readdy.ai/api/search-image?query=A%20fresh%20and%20playful%20manga%20cover%20illustration%20with%20a%20cheerful%20tomato%20mascot%20and%20happy%20anime%20characters%2C%20bright%20red%20and%20green%20color%20palette%2C%20cute%20clean%20illustration%20style%2C%20lighthearted%20comic%20mood%2C%20friendly%20and%20approachable&width=600&height=800&seq=app-fanqie&orientation=portrait",
    summary:
      "主打全免费阅读的漫画应用，书库覆盖海量国漫与各类题材，无需付费即可畅读。通过看广告或完成任务解锁更多内容，适合预算有限、追更数量多、想低成本看大量漫画的读者。",
    pros: ["完全免费", "书库庞大", "零门槛"],
    cons: ["需看广告解锁", "部分资源画质一般"],
    bestFor: "追求免费海量阅读的漫画爱好者",
  },
  {
    id: "manman",
    name: "漫漫漫画",
    tagline: "青春少女向漫画社区",
    category: "国漫原创",
    rating: 4.4,
    score: 82,
    platforms: ["iOS", "Android", "Web"],
    price: "免费+会员",
    tags: ["少女向", "情感题材", "社区"],
    cover: "https://readdy.ai/api/search-image?query=A%20soft%20pastel%20romance%20manga%20cover%20with%20two%20blushing%20teenage%20characters%20in%20spring%20cherry%20blossom%20scene%2C%20gentle%20peach%20and%20cream%20tones%2C%20delicate%20anime%20lineart%2C%20dreamy%20soft%20light%2C%20sweet%20youthful%20romance%20mood&width=600&height=800&seq=app-manman&orientation=portrait",
    summary:
      "专注少女向与情感题材的原创漫画社区，连载以校园、恋爱、成长为主线，画风细腻温柔。社区讨论区活跃，读者可以与作者互动，适合喜欢青春恋爱题材与氛围感的用户。",
    pros: ["少女向专精", "画风细腻", "社区互动"],
    cons: ["题材相对垂直"],
    bestFor: "钟爱青春恋爱题材的用户",
  },
  {
    id: "manhuadao",
    name: "漫画岛",
    tagline: "聚合海量漫画资源",
    category: "免费追更",
    rating: 4.3,
    score: 80,
    platforms: ["iOS", "Android"],
    price: "免费",
    tags: ["资源聚合", "题材丰富", "一站式"],
    cover: "https://readdy.ai/api/search-image?query=A%20colorful%20collection%20of%20diverse%20anime%20and%20manga%20characters%20arranged%20in%20a%20collage%20on%20an%20island%20theme%2C%20vibrant%20multicolor%20palette%2C%20celebratory%20comic%20style%2C%20many%20different%20genres%20represented%2C%20energetic%20and%20playful%20illustration&width=600&height=800&seq=app-manhuadao&orientation=portrait",
    summary:
      "聚合大量漫画资源的综合应用，题材覆盖热血、玄幻、都市、悬疑等几乎全部分类，一站满足不同口味。分类清晰、搜索方便，适合想看多种题材又懒得来回切换不同应用的用户。",
    pros: ["题材覆盖全", "分类清晰", "一站式阅读"],
    cons: ["部分资源来源较杂"],
    bestFor: "想看多种题材的综合型读者",
  },
  {
    id: "zhuiman",
    name: "追漫日记",
    tagline: "跨平台追更管理助手",
    category: "追更管理",
    rating: 4.5,
    score: 84,
    platforms: ["iOS", "Android", "Web"],
    price: "免费",
    tags: ["追更管理", "跨平台同步", "提醒"],
    cover: "https://readdy.ai/api/search-image?query=A%20clean%20flat%20illustration%20of%20a%20comic%20reading%20planner%20with%20calendar%20notebook%20and%20comic%20bookmark%20icons%2C%20warm%20amber%20and%20cream%20color%20palette%2C%20minimalist%20organizer%20theme%2C%20organized%20neat%20layout%2C%20friendly%20utility%20app%20mood&width=600&height=800&seq=app-zhuiman&orientation=portrait",
    summary:
      "面向多开漫画应用的重度追更党的管理助手，自动记录各平台的在追作品，统一提醒更新，告别漏更焦虑。支持导入常用平台书单、自定义分组与离线记录，让跨平台追更变得井井有条。",
    pros: ["跨平台管理", "更新提醒", "免费实用"],
    cons: ["需配合其他阅读器使用"],
    bestFor: "同时追更多部作品的重度用户",
  },
  {
    id: "buka",
    name: "布卡漫画",
    tagline: "经典怀旧漫画重温",
    category: "正版日漫",
    rating: 4.2,
    score: 78,
    platforms: ["iOS", "Android"],
    price: "免费+内购",
    tags: ["经典怀旧", "日漫老番", "收藏"],
    cover: "https://readdy.ai/api/search-image?query=A%20retro%20vintage%20comic%20book%20cover%20illustration%20in%20classic%20hand%20drawn%20manga%20style%20from%20the%2080s%20and%2090s%2C%20faded%20warm%20paper%20texture%2C%20nostalgic%20golden%20brown%20tone%2C%20classic%20ink%20linework%2C%20memorable%20old%20school%20charm&width=600&height=800&seq=app-buka&orientation=portrait",
    summary:
      "专注经典老番与怀旧日漫的应用，收录大量上世纪八九十年代的口碑作品，适合重温童年记忆与补番老作品。界面简洁，收藏与阅读记录本地保存，是情怀读者的温暖选择。",
    pros: ["经典老番齐全", "界面简洁", "情怀满满"],
    cons: ["新作更新较慢"],
    bestFor: "想重温经典老番的怀旧读者",
  },
];